import React, { useState } from 'react';
import './Services.css';
import FlowingMenu from './FlowingMenu';

const Services = () => {
  const [selectedService, setSelectedService] = useState(null);

  // Enhanced portfolio data with more variety
  const portfolioData = {
    ads: [
      { id: 1, title: "E-commerce Campaign", image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=250&fit=crop", description: "Increased ROI by 300% with targeted Facebook ads" },
      { id: 2, title: "Social Media Ads", image: "https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=400&h=250&fit=crop", description: "2M+ impressions across Instagram and TikTok" },
      { id: 3, title: "Brand Awareness Campaign", image: "https://images.unsplash.com/photo-1553830591-fddf9c784d53?w=400&h=250&fit=crop", description: "40% engagement boost through strategic placement" }
    ],
    website: [
      { id: 1, title: "Restaurant Website", image: "https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=400&h=250&fit=crop", description: "Modern, responsive design with online ordering" },
      { id: 2, title: "E-commerce Store", image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=400&h=250&fit=crop", description: "Full shopping experience with payment integration" },
      { id: 3, title: "Portfolio Website", image: "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=400&h=250&fit=crop", description: "Creative showcase with dynamic animations" },
      { id: 4, title: "Corporate Landing Page", image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=400&h=250&fit=crop", description: "Professional B2B lead generation site" }
    ],
    social: [
      { id: 1, title: "Instagram Growth Strategy", image: "https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=400&h=250&fit=crop", description: "50K+ followers growth in 6 months" },
      { id: 2, title: "TikTok Viral Campaign", image: "https://images.unsplash.com/photo-1611605698335-8b1569810432?w=400&h=250&fit=crop", description: "3M+ views with trending content strategy" },
      { id: 3, title: "LinkedIn B2B Content", image: "https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=400&h=250&fit=crop", description: "Generated 150 qualified B2B leads" },
      { id: 4, title: "YouTube Channel Setup", image: "https://images.unsplash.com/photo-1611162616475-46b635cb6868?w=400&h=250&fit=crop", description: "Complete channel optimization and content plan" }
    ],
    design: [
      { id: 1, title: "Brand Identity Package", image: "https://images.unsplash.com/photo-1558655146-d09347e92766?w=400&h=250&fit=crop", description: "Complete logo, colors, and brand guidelines" },
      { id: 2, title: "Custom Illustrations", image: "https://images.unsplash.com/photo-1541701494587-cb58502866ab?w=400&h=250&fit=crop", description: "Unique artwork for digital campaigns" },
      { id: 3, title: "UI/UX Design System", image: "https://images.unsplash.com/photo-1559028006-448665bd7c7f?w=400&h=250&fit=crop", description: "User-centered design with accessibility focus" },
      { id: 4, title: "Print & Digital Assets", image: "https://images.unsplash.com/photo-1542744094-3a31f272c490?w=400&h=250&fit=crop", description: "Business cards, flyers, and social media templates" }
    ]
  };

  const services = [
    {
      id: 'ads',
      title: 'Media Buying',
      description: 'Strategic ad placements that maximize ROI through data-driven targeting',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=250&fit=crop'
    },
    {
      id: 'website',
      title: 'Social Media Management',
      description: 'Building engaged communities through authentic content and interaction',
      image: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=400&h=250&fit=crop'
    },
    {
      id: 'social',
      title: 'Photography & Video',
      description: 'Professional visual content that tells your brand story effectively',
      image: 'https://images.unsplash.com/photo-1598387993441-a364f854c3e1?w=400&h=250&fit=crop'
    },
    {
      id: 'design',
      title: 'User Generated Content',
      description: 'Authentic customer content that builds trust and drives engagement',
      image: 'https://images.unsplash.com/photo-1558655146-d09347e92766?w=400&h=250&fit=crop'
    }
  ];

  // Create menu items for FlowingMenu
  const menuItems = services.map(service => ({
    link: '#',
    text: service.title,
    description: service.description,
    image: service.image,
    onClick: () => setSelectedService(selectedService === service.id ? null : service.id)
  }));

  const renderPortfolio = () => {
    if (!selectedService) return null;
    
    const currentService = services.find(s => s.id === selectedService);
    
    return (
      <div className="portfolio-modal" onClick={() => setSelectedService(null)}>
        <div className="portfolio-modal-content" onClick={(e) => e.stopPropagation()}>
          <button 
            className="portfolio-modal-close"
            onClick={() => setSelectedService(null)}
          >
            ×
          </button>
          <h3 className="portfolio-modal-title">{currentService?.title}</h3>
          <p className="portfolio-modal-description">{currentService?.description}</p>
          <div className="portfolio-grid">
            {portfolioData[selectedService]?.map((item) => (
              <div key={item.id} className="portfolio-item">
                <div className="portfolio-image">
                  <img src={item.image} alt={item.title} />
                </div>
                <div className="portfolio-content">
                  <h5>{item.title}</h5>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className="services" id="services">
      <div className="container">
        <h2 className="section-title">What we'll do for you</h2>
        
        <div className="services-flowing-container">
          <FlowingMenu items={menuItems} />
        </div>

        {/* Portfolio showcase when service is selected */}
        {renderPortfolio()}
      </div>
    </section>
  );
};

export default Services;